import { spacing, fontSize, borderRadius, lineHeight } from '../../theme/theme';

import styled from 'styled-components';

export const Input = styled.div`
  position: relative;
  display: ${({ type }) => (type === 'hidden' ? 'block' : 'inline-block')};
  width: ${({ width }) => (width ? `${width}%` : 'auto')};

  label {
    position: absolute;
    left: ${({ hasIcon }) =>
      hasIcon ? `${spacing.xxxl}px` : `${spacing.md}px`};
    top: ${({ active }) => (active ? `${spacing.xs}px` : `${spacing.lg}px`)};
    font-size: ${({ active }) => (active ? fontSize.xs : fontSize.base)};
    transition: 0.2s all;
    display: ${({ type }) => (type === 'hidden' ? 'none' : 'block')};
  }

  input {
    padding: ${spacing.lg} ${spacing.md};
    background: #ffffff;
    border: 1px solid #c4c4c4;
    box-sizing: border-box;
    font-family: Oxygen;
    display: block;
    font-style: normal;
    font-weight: normal;
    font-size: ${fontSize.base};
    line-height: ${lineHeight.base};
    outline: 0;
    color: ${({ active }) => (active ? '#000' : 'transparent')};
    border-top-left-radius: ${({ topLeftCornerRadius }) =>
      topLeftCornerRadius ? borderRadius.base : '0'};
    border-top-right-radius: ${({ topRightCornerRadius }) =>
      topRightCornerRadius ? borderRadius.base : '0'};
    border-bottom-left-radius: ${({ bottomLeftCornerRadius }) =>
      bottomLeftCornerRadius ? borderRadius.base : '0'};
    border-bottom-right-radius: ${({ bottomRightCornerRadius }) =>
      bottomRightCornerRadius ? borderRadius.base : '0'};
    width: 100%;
    padding-left: ${({ hasIcon }) =>
      hasIcon ? `${spacing.xxxl}px` : `${spacing.md}px`};
  }

  > .errors {
    position: absolute !important;
    color: red;
    bottom: ${spacing.xs}px;
    left: ${spacing.md}px;
    font-size: ${fontSize.xs};
  }

  .icon {
    position: absolute;
    top: ${spacing.lg}px;
    left: ${spacing.md}px;
  }
`;
